import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import CommonService from '@/services/CommonService';
import { PURGE_AUTH, SET_MESSAGE_MODAL } from '@/store/mutation-types';

export const status = {
  HTTP_BAD_REQUEST: 400,
  HTTP_UNAUTHORIZED: 401,
  HTTP_FORBIDDEN: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_INTERNAL_SERVER_ERROR: 500,
};

export default (inline = false, contentType = 'application/json') => {
  const { user, token } = store.state.auth;
  const apiUrl = process.env.VUE_APP_API_URL
    ? process.env.VUE_APP_API_URL
    : ('https://' + location.hostname + '/api');
  const axiosInstance = axios.create({
    baseURL: apiUrl,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': contentType,
      'X-Pos-Auth': CommonService.generateJWT(user.username, token),
    },
  });

  axiosInstance.interceptors.request.use(function (config) {
    store.state.bill.ajaxCounter++;
    const user = store.state.auth.user;
    if (user && user.location && user.location.id) {
      config.headers['X-Pos-Location'] = user.location.id;
    }
    config.headers['X-Pos-Timer'] = Math.floor(Date.now() / 1000);
    return config;
  });

  axiosInstance.interceptors.response.use((response) => {
    store.state.bill.ajaxCounter--;
    if (response.data.ping) {
      const { $dayjs } = Vue.prototype;
      store.state.bill.lastPing = response.data.datetime;
    }
    return response;
  }, (error) => {
    if(store.state.bill.ajaxCounter > 0) {
      store.state.bill.ajaxCounter --;
    }
    if (error.message == 'Network Error') {
      let data = {
        error: "Network Error",
        code: 500
      };
      store.commit(SET_MESSAGE_MODAL, data);
      return false;
    }
    if (error.response.status === status.HTTP_UNAUTHORIZED
      && error.config.url !== (`${process.env.VUE_APP_API_URL}/auth`)) {
      store.commit(SET_MESSAGE_MODAL, error.response.data);
      store.commit(PURGE_AUTH);
      window.location.reload();
    }

    if (inline) {
      return Promise.reject(error.response.data);
    }
    if (error.response.status === status.HTTP_BAD_REQUEST
      || error.response.status === status.HTTP_FORBIDDEN
      || error.response.status === status.HTTP_NOT_FOUND
      || error.response.status === status.HTTP_INTERNAL_SERVER_ERROR) {
      store.commit(SET_MESSAGE_MODAL, error.response.data);
      // clean up auth
      // on location not found
      if (error.response.data.redirect) {
        window.location.replace(error.response.data.redirect);
      }
      if (error.response.status === status.HTTP_NOT_FOUND
        && error.response.data.entity == 'Location') {
        store.commit(PURGE_AUTH);
        window.location.reload();
      }
    }
    return false;
  });

  return axiosInstance;
};
